import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '../constants/app.constans';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly ALLOWED_FILE_TYPES = ['.docx', '.pdf'];
  private readonly MAX_FILE_SIZE = AppConstants.MAX_FILE_SIZE // 50MB

  constructor(private toastr: ToastrService) {}
 

  validateFile(file: File, isSkillSet: boolean = false): boolean {
  const extension = file.name.split('.').pop()?.toLowerCase();

  const defaultExtensions = [
    'pdf',
    'docx'
  ];

  const skillSetExtensions = [
    'pdf',
    'docx',
    'png',
    'jpg',
    'jpeg',
    'bmp',
    'tiff',
    'ppt',
    'pptx',
    'xlsx',
    'png'
  ];

  const allowedExtensions = isSkillSet
    ? skillSetExtensions
    : defaultExtensions;

  if (!extension || !allowedExtensions.includes(extension)) {
    return false;
  }

  return true;
}

  getFileExtension(filename: string): string {
    return filename.substring(filename.lastIndexOf('.'));
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getAllowedFileTypes(): string {
    return this.ALLOWED_FILE_TYPES.join(', ');
  }

  getMaxFileSizeMB(): number {
    return this.MAX_FILE_SIZE / (1024 * 1024);
  }
}
